import {
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import { BlogState } from './reducer/blog.reducer';

export interface State {
  blog: BlogState,
}

const blogState = createFeatureSelector<BlogState>('blog');

export const blogSelector = createSelector(
  blogState,
  (state: BlogState) => state
);
